import { render, staticRenderFns } from "./system_partner.vue?vue&type=template&id=c2b855b8&scoped=true&"
import script from "./system_partner.vue?vue&type=script&lang=js&"
export * from "./system_partner.vue?vue&type=script&lang=js&"
import style0 from "./system_partner.vue?vue&type=style&index=0&id=c2b855b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b855b8",
  null
  
)

export default component.exports